import type { ReactNode } from "react";
import { Center, Loader } from "@mantine/core";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/stores/auth";

/**
 * Route guard for the platform-admin section. Mirrors the API's
 * RequireSystemAdminDB gate — this only shapes navigation; the API enforces.
 */
export function RequireSystemAdmin({ children }: { children: ReactNode }) {
  const isSystemAdmin = useAuthStore((s) => s.isSystemAdmin);
  const isLoading = useAuthStore((s) => s.isLoading);

  if (isLoading) {
    return (
      <Center py="xl">
        <Loader size="md" />
      </Center>
    );
  }
  if (!isSystemAdmin) return <Navigate to="/inbox" replace />;
  return <>{children}</>;
}
